"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";

export function useRouteChange(
    handler: (url: string) => void,
    options?: { ignoreSearchParams?: boolean }
) {
    const pathname = usePathname();
    const searchParams = useSearchParams();

    useEffect(
        () => {
            const url = `${pathname}?${searchParams.toString()}`;
            handler(url);
        },
        options?.ignoreSearchParams ? [pathname] : [pathname, searchParams]
    );
}
